import { render } from "./CodePage.vue?vue&type=template&id=3e8c4be4&scoped=true"
import script from "./CodePage.vue?vue&type=script&lang=js"
export * from "./CodePage.vue?vue&type=script&lang=js"

import "./CodePage.vue?vue&type=style&index=0&id=3e8c4be4&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e8c4be4"]])

export default __exports__